/* eslint-disable camelcase */
export const HTTP_STATUS_OK = 200;
export const DOI_URL = '/campaign/?doi=1';
export const DOI_ERROR_CODE = 11;
export const EMAIL_ERROR_CODE = 12;
export const USER_LOGGED_IN_ERROR_CODE = 20;
export const PASSWORD_ERROR_CODE = 10;
export const INTERNAL_ERROR_CODE = 1;

// TODO Club - implement missing features, see commented lines
// export const VALIDATE_REGISTRATION_EMAIL_URL = 'register/ValidateEmail/?isUnique=true&returnFormat=json';

export const CUSTOM_DOI_OVERLAY_USER_DATA = 'custom_doi_overlay_user_data';

export const API_BASE_URL = '/authapi/';

export const CLUB_API_BASE_URL = '/club-api/authapi/';

export const STATUS = {
    SUCCESS: 'success',
    ERROR: 'error',
};

export const SIGNUP_API = {
    URL: 'register/?type=emailandpassword&returnFormat=json',
    // PASSWORDLESS_URL: 'register/?type=emailonly&returnFormat=json',
};

export const LOGIN_API = {
    URL: 'login/?returnFormat=json',
    // MAGIC_LINK_URL: 'login/?returnFormat=json',
    // MAGIC_LINK_REDIRECT_URL: '/customer/account/magiclinksent/',
};

export interface ClubRegisterResponse {
    status: string;
    error?: ResponseError;
    response_data?: ResponseData;
    request_params: { [key: string]: string } | null;
}

export type ResponseError = {
    code: number;
    message: string;
    validation_errors?: [{ [key: string]: string[] }];
};

export type ResponseData = {
    user_id: string;
    loginHash: string;
};
